export default __webpack_public_path__ + "static/media/digital.17384618.svg";